import { Map } from 'immutable';

export const UPDATE_SCREEN_ID = 'modules/axp-gravity-page-wrapper/UPDATE_SCREEN_ID';
export const UPDATE_SHOW_DIALOG = 'modules/axp-gravity-page-wrapper/UPDATE_SHOW_DIALOG';
export const UPDATE_STATIC_MESSAGE = 'modules/axp-gravity-page-wrapper/UPDATE_STATIC_MESSAGE';
export const UPDATE_UCD_RESPONSE = 'modules/axp-gravity-page-wrapper/UPDATE_UCD_RESPONSE';
export const UPDATE_NCD_RESPONSE = 'modules/axp-gravity-page-wrapper/UPDATE_NCD_RESPONSE';
export const UPDATE_OTC_RESPONSE = 'modules/axp-gravity-page-wrapper/UPDATE_OTC_RESPONSE';
export const LANG = 'modules/axp-gravity-page-wrapper/LANG';
export const TIMEOUT = 'modules/axp-gravity-page-wrapper/TIMEOUT';
export const SETTINGSDATA = 'modules/axp-gravity-page-wrapper/SETTINGSDATA';
export const SETTINGSCLICKED = 'modules/axp-gravity-page-wrapper/SETTINGSCLICKED';
export const UPDATE_ABANDON_DATA = 'modules/axp-gravity-page-wrapper/UPDATE_ABANDON_DATA';
export const UPDATE_COMPLETION_DATA = 'modules/axp-gravity-page-wrapper/UPDATE_COMPLETION_DATA';
export const UPDATE_FLOW_DATA = 'modules/axp-gravity-page-wrapper/UPDATE_FLOW_DATA';

const showConfirmationDialog = (event) => {
  event.preventDefault();
  /* eslint-disable no-param-reassign */
  event.returnValue = '';
};

const logAbandon = (_, {
  postUrl, queryParams, currentScreenId, incomingReq,
}) => {
  // if same domain solution active
  if (incomingReq) {
    const data = {
      screenId: currentScreenId,
      eventCode: 'abandon',
      'acs-trans-id': queryParams.acsTransId,
      Authorization: queryParams.token,
    };
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(data)], {
        type: 'application/json',
      });
      navigator.sendBeacon(postUrl, blob);
    } else {
      // navigator API unavailable, use old method (IE)
      const req = new XMLHttpRequest();
      req.open('POST', postUrl, false);
      req.setRequestHeader('Content-Type', 'application/json');
      req.send(JSON.stringify(data));
    }
  } else {
    const data = new FormData();
    data.append('acs-trans-id', queryParams.acsTransId);
    data.append('screenId', currentScreenId);
    data.append('eventCode', 'abandon');
    data.append('Authorization', queryParams.token);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(postUrl, data);
    } else {
      const req = new XMLHttpRequest();
      req.open('POST', postUrl, false);
      req.send(data);
    }
  }
};

const initialState = new Map({
  currentScreenId: null,
  showDialog: false,
  staticMessage: '',
  ucdResponse: {},
  ncdResponse: {},
  otcResponse: {},
  currentLanguage: '',
  screenTimeout: true,
  settingsData: '',
  settingsClicked: false,
  abandonData: null,
  completionData: {
    btnId: null,
    isVerified: null,
  },
  flow: {},
});

/* eslint complexity: ["error", 30] */
export default function reducer(state = initialState, { type, payload }) {
  const abandonHandler = (event) => logAbandon(event, payload);
  const abandonData = state.get('abandonData');
  switch (type) {
    case UPDATE_SCREEN_ID:
      return state.set('currentScreenId', payload);
    case UPDATE_SHOW_DIALOG:
      if (payload === true) window.addEventListener('beforeunload', showConfirmationDialog);
      if (payload === false) {
        window.removeEventListener('beforeunload', showConfirmationDialog);
        if (abandonData) window.removeEventListener('unload', abandonData.abandonHandler);
      }
      return state.set('showDialog', payload);
    case UPDATE_STATIC_MESSAGE:
      return state.set('staticMessage', payload);
    case UPDATE_UCD_RESPONSE:
      return state.set('ucdResponse', payload);
    case UPDATE_NCD_RESPONSE:
      return state.set('ncdResponse', payload);
    case UPDATE_COMPLETION_DATA:
      return state.set('completionData', payload);
    case LANG: return state.set('currentLanguage', payload);
    case TIMEOUT: return state.set('screenTimeout', payload);
    case SETTINGSDATA: return state.set('settingsData', payload);
    case SETTINGSCLICKED: return state.set('settingsClicked', payload);
    case UPDATE_ABANDON_DATA:
      if (abandonData) window.removeEventListener('unload', abandonData.abandonHandler);
      window.addEventListener('unload', abandonHandler);
      return state.set('abandonData', { ...payload, abandonHandler }); // keep reference to abandon handler across reducer calls
    case UPDATE_OTC_RESPONSE:
      return state.set('otcResponse', payload);
    case UPDATE_FLOW_DATA:
      return state.set('flow', payload);
    default:
      return state;
  }
}
